// ----------------------------------------------------------------------
// <copyright file="Izenda.RelationshipList.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//
// </copyright>
// ----------------------------------------------------------------------

/**
 * Relationship List component
 */
!(function() {
  var commonMessages = require('share/messages/Izenda.CommonMessages');

  var React = require('react');
  var ReactDOM = require('react-dom');
  var m = require('mobx');
  var observable = require('mobx').observable;
  var connect = require('share/enhancers/Izenda.Connect');
  var Dimensions = require('share/components/hoc/Izenda.Dimensions');
  var uiState = require('logic/Izenda.UiState');

  var ScrollBox = require('share/components/controls/Izenda.ScrollBox');
  var Table = require('share/components/controls/DataGrid/Izenda.Table').Table;
  var Column = require('share/components/controls/DataGrid/Izenda.Table').Column;
  var Paginator = require('share/components/controls/DataGrid/helpers/Izenda.Paginator');

  var JoinTypeColumn = require('./Izenda.JoinTypeColumn');
  var PositionIdColumn = require('./Izenda.PositionIdColumn');
  var DatabaseColumn = require('./Izenda.DatabaseColumn');
  var DataObjectColumn = require('./Izenda.DataObjectColumn');
  var JoinFieldColumn = require('./Izenda.JoinFieldColumn');
  var ForeignDatabaseColumn = require('./Izenda.ForeignDatabaseColumn');
  var ForeignDataObjectColumn = require('./Izenda.ForeignDataObjectColumn');
  var ForeignJoinFieldColumn = require('./Izenda.ForeignJoinFieldColumn');
  var ActionColumn = require('./Izenda.ActionColumn');
  var constants = require('logic/data/Izenda.ReportDesignerConstants');
  var DataModelConstants = require('logic/data/Izenda.DataModelConstants');
  var fieldCheck = require('logic/data/Izenda.RelationshipConstants').FIELDCHECK;
  var TableDefinition = DataModelConstants.TableDefinition;
  const { getOr } = require('lodash/fp');

  var RelationshipList = React.createClass({
    propTypes: {
      store: React.PropTypes.object.isRequired,
      isPopup: React.PropTypes.bool,
      isHideActionColumn: React.PropTypes.bool,
      isHidePaging: React.PropTypes.bool,
      isSort: React.PropTypes.bool
    },

    componentWillMount: function() {
      this.size = observable({ height: 0 });

      var validation = this.props.validation;
      this.disposeObserveTenantID = m.observe(
        uiState,
        'tenantId',
        function() {
          validation.reset();
        }
      );
    },

    componentDidMount: function() {
      var dom = ReactDOM.findDOMNode(this);
      var domHeight = dom.clientHeight;
      domHeight > 0
        && domHeight !== this.size.height
        && (this.size.height = domHeight);
    },

    componentWillUnmount: function() {
      this.disposeObserveTenantID();
    },

    getDefaultProps: function() {
      return {
        isSort: true
      };
    },

    onSortChange: function(columnKey, sortDir) {
      if (!this.props.isSort) {
        return;
      }

      var { store, validation } = this.props;

      const refreshData = () => {
        this.props.validation.reset();
        store.pageInfo.setColSortDirs(columnKey, sortDir);

        if (store.showInvalidScreen) {
          return store.getInvalidRelationships().then(() => {
            const allErrors = store.getInvalidErrors(fieldCheck);
            validation.updateErrors(allErrors);
          });
        }

        return store.getRelationships();
      };
      // Sorting in Invalid Screen
      if (store.showInvalidScreen) {
        return refreshData();
      }

      return this.props.confirmDirtyForm(store.hasChange).then(refreshData);
    },

    onPageSizeChange: function(pageSize) {
      return this.props.confirmDirtyForm(this.props.store.hasChange).then(() => {
        this.props.validation.reset();
        this.props.store.pageInfo.setPageSize(pageSize);
        return this.goToPage(1);
      });
    },

    goToPage: function(pageIndex) {
      return this.props.confirmDirtyForm(this.props.store.hasChange).then(() => {
        this.props.validation.reset();
        this.props.store.goToPage(pageIndex);
      });
    },

    /**
     * render main function
     */
    render: function() {
      var store = this.props.store;
      var props = this.props;
      var size = this.size;

      var relationshipList = store.relationshipList;
      var currentPageSize = getOr(0, 'length', relationshipList);
      var TABLE_DEF = TableDefinition.Relationship;

      var actualHeight = (props.height || size.height || DataModelConstants.DEFAULT_TABLE_HEIGHT) - DataModelConstants.DEFAULT_REST_HEIGHT;
      return (
        <div className="izenda-Wrapper">
          <ScrollBox>
            <section className="u_paddingLeftRight u_fullHeight">
              <Table
                dataSource={relationshipList}
                rowProps={this.getRowProps}
                onSortChange={this.onSortChange}
                sortInfo={props.isSort ? store.pageInfo.colSortDirs : ''}
                minHeight={actualHeight}
                maxHeight={actualHeight}
                isLoading={props.isLoading}
              >
                {/* Join Type */}
                <Column {...TABLE_DEF['joinType']} cell={JoinTypeColumn.bind(this)} />

                {/* Position ID */}
                {!this.props.isPopup &&
                  <Column {...TABLE_DEF['positionId']} cell={PositionIdColumn.bind(this)} />}

                {/* Database name */}
                <Column {...TABLE_DEF['dbName']} cell={DatabaseColumn.bind(this)} />

                {/* data Object */}
                <Column {...TABLE_DEF['dataObject']} cell={DataObjectColumn.bind(this)} />

                {/* join Field */}
                <Column {...TABLE_DEF['joinField']} cell={JoinFieldColumn.bind(this)} />

                {/* join Field */}
                <Column {...TABLE_DEF['equal']} cell={<div className="equal-sign-in-cell u_textCenter">=</div>} />

                <Column {...TABLE_DEF['frDbName']} cell={ForeignDatabaseColumn.bind(this)} />

                {/* Database name */}
                <Column {...TABLE_DEF['frDataObject']} cell={ForeignDataObjectColumn.bind(this)} />

                {/* data Object */}
                <Column {...TABLE_DEF['frField']} cell={ForeignJoinFieldColumn.bind(this)} />

                {/* action */}
                {!this.props.isHideActionColumn &&
                  <Column {...TABLE_DEF['action']} cell={ActionColumn.bind(this)} />}
              </Table>
            {!this.props.isHidePaging &&
              <Paginator
                onChange={this.goToPage}
                onDropdownChange={this.onPageSizeChange}
                pageInfo={store.pageInfo}
                currentPageSize={currentPageSize}
              />}
            </section>
          </ScrollBox>
        </div>
      );
    },
    getRowProps: function(spDetails) {
      var store = this.props.store;

      if (!store.selectedQuerySource) {
        return null;
      }

      return {
        className: spDetails.isSelected ? 'selected-row' : ''
      };
    },

    /**
     * check existing entities with current relationship
     * @param {Object} relationshipItem
     * @param {String} currentValue
     * @param {Function} rollbackValueFunc
     */
    checkExistEntities: function(relationshipItem, currentValue, rollbackValueFunc) {
      var props = this.props;
      var store = props.store;
      var existedItem = store.checkExistEntities(relationshipItem);

      var updateValue = function() {
        store.updateJoinTypeForSameEntities(relationshipItem, true);
      };
      var rollbackValue = function() {
        rollbackValueFunc.call(relationshipItem, currentValue);
      };

      if (existedItem) {
        var message = String.format(
          constants.BUNDLE.MESSAGE.CHANGE_JOIN_TYPE,
          existedItem.joinQuerySourceName,
          existedItem.foreignQuerySourceName
        );

        props
          .confirmFn('Confirmation', { description: message })
          .then(updateValue)
          .catch(rollbackValue);
      } else {
        updateValue();
      }
    }
  });

  module.exports = connect(Dimensions)(RelationshipList);
})();



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/DataModel/Relationship/Izenda.RelationshipList.jsx